import { useTranslation } from 'react-i18next'
import {
  formatImeiHubPriceEur,
  imeiHubRetailPriceEurCents,
  isImeiHubPaidService,
  type ImeiHubServiceId,
} from '@redevicer/shared'

type Props = {
  service: ImeiHubServiceId
  /** From /imei/catalog when Stripe live; falls back to catalog defaults. */
  priceEurCents?: number | null
  variant?: 'card' | 'panel' | 'picker'
}

export default function ImeiHubServicePriceBadge({
  service,
  priceEurCents,
  variant = 'card',
}: Props) {
  const { t, i18n } = useTranslation()
  const paid =
    typeof priceEurCents === 'number' || (priceEurCents == null && isImeiHubPaidService(service))

  const cents =
    priceEurCents ??
    imeiHubRetailPriceEurCents(service) ??
    (paid ? null : 0)

  if (paid && cents == null) return null

  const label = paid
    ? formatImeiHubPriceEur(cents!, i18n.language)
    : variant === 'card' || variant === 'picker'
      ? t('vc.imeiHub.pricing.cardFree')
      : t('vc.imeiHub.pricing.includedFree')

  return (
    <span
      className={`vc-imei-hub__price-badge vc-imei-hub__price-badge--${variant}${paid ? ' vc-imei-hub__price-badge--paid' : ' vc-imei-hub__price-badge--free'}`}
    >
      {label}
    </span>
  )
}
